import { DocumentSemanticSearchCurationMode } from '../../graphql-types'

/** Default GraphQL flags for Mosaic search (no UI toggles). */
export const MOSAIC_SEARCH_INCLUDE_SUMMARY = true
export const MOSAIC_SEARCH_INCLUDE_TRANSITIONS = true

/**
 * Curation mode presets for Semantic Stitch (UI picker).
 * Preset IDs match Brooklyn `DocumentSemanticSearchCurationMode` enum values.
 */

export const CURATION_MODE_BEST_MATCHES = DocumentSemanticSearchCurationMode.BestMatches
export const CURATION_MODE_WIDE_LENS = DocumentSemanticSearchCurationMode.WideLens
export const CURATION_MODE_DEEP_DIVE = DocumentSemanticSearchCurationMode.DeepDive
export const CURATION_MODE_LEARNING_PATH = DocumentSemanticSearchCurationMode.LearningPath

export const DEFAULT_CURATION_MODE = CURATION_MODE_BEST_MATCHES

/** Curation modes rendered in the preset picker. */
export const CURATION_MODE_PRESETS = [
  CURATION_MODE_BEST_MATCHES,
  CURATION_MODE_WIDE_LENS,
  CURATION_MODE_DEEP_DIVE,
  CURATION_MODE_LEARNING_PATH,
]

/** Static text keys in `semanticStitchPage` for preset card titles. */
export const CURATION_MODE_LABEL_KEY = {
  [CURATION_MODE_BEST_MATCHES]: 'presetBestMatches',
  [CURATION_MODE_WIDE_LENS]: 'presetWideLens',
  [CURATION_MODE_DEEP_DIVE]: 'presetDeepDive',
  [CURATION_MODE_LEARNING_PATH]: 'presetLearningPath',
}

/** Static text keys in `semanticStitchPage` for preset card subtitles. */
export const CURATION_MODE_DESC_KEY = {
  [CURATION_MODE_BEST_MATCHES]: 'presetBestMatchesDesc',
  [CURATION_MODE_WIDE_LENS]: 'presetWideLensDesc',
  [CURATION_MODE_DEEP_DIVE]: 'presetDeepDiveDesc',
  [CURATION_MODE_LEARNING_PATH]: 'presetLearningPathDesc',
}
